import { Component } from '@angular/core';
import {SubscribeComponent} from "../../common/subscribe/subscribe.component";
import {RouterLink} from "@angular/router";

@Component({
  selector: 'app-spende',
  standalone: true,
    imports: [
        SubscribeComponent,
        RouterLink
    ],
  templateUrl: './spende.component.html',
  styleUrl: './spende.component.scss'
})
export class SpendeComponent {

}
